<template>
  <div class="login top-pad">
    <div
      v-show="Loginloaded"
      class="login-page-wrapper"
      :style="'background-image:Url(' + pageBg + ')'"
    >
      <div class="login-inner page-effect">
        <div class="login-section">
          <div class="l-logo-area">
            <img id="imgLogo" v-bind:src="brandlogo" />
          </div>
          <div id="dvLogin">
            <div class="l-login-text-head">
              <h3
                id="h3HeaderLabel"
                class="login-head"
                v-bind:style="'color:' + bodyTextColor + ' !important;'"
              >
                LOGGING IN...
              </h3>
            </div>
            <br />
            <router-link
              id="lnkLogin"
              v-show="showLogin"
              size="large"
              class="btn-back login-form"
              to="/"
              >Return To Login</router-link
            >
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col-md-10 mx-auto mt-4">
            <div class="or">
              <span id="spnInfoText"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="!Loginloaded"
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <div class="loader">
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
    <!-- Othe msg  Modal -->
    <div class="modal fade all-modal" id="Othermsg-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              An error occurred during authentication. Please try again.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="overlay-test" class="login-attendee">
      <div class="attendee-img-hld mx-auto" id="userInitials">
        {{ userInitials }}
      </div>
      <div class="attendee-img-hld mx-auto d-none" id="user-profile-img">
        <img :src="userImage" class="imguserthumb" v-on:load="loadImage()" />
      </div>

      <div class="welcome-attendee">
        <span class="welcome">Welcome </span>
        <span class="attendee">{{ userFirstName }}!</span>
      </div>
      <div>
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->
  </div>
</template>
<style></style>
<script>
import GoogleSignInButton from "vue-google-signin-button-directive";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import firebase from "firebase";
import "firebase/auth";
import axios from "axios";
import router from "../router";
import store from "../store";
import APIs from "@/components/APIInit";
import jwt_decode from "jwt-decode";
import common from "@/common";
import analytics from "@/components/Analytics";

const landingURLOptions = {
  "/lobby": "Lobby",
  "/sessions": "Sessions",
  "/livestage": "LiveStage",
  "/stageview": "StageView",
  "/attendee": "AttendeeList",
  "/exhibitorshall": "ExhibitorsHall",
  "/mymeetings": "MyMeetings",
  "/myprofile": "MyProfile",
};

var self;
var interval;
export default {
  directives: {
    GoogleSignInButton,
  },
  data: () => ({
    showLogin: false,
    clientId:
      "119219268154-amccobf15ophtvhaui1h7rkfo222d9eg.apps.googleusercontent.com",
    result: "",
    client: "",
    EmailURL: "",
    DynamicColor: "",
    arrEvents: [],
    hostExistcnt: 0,
    Loginloaded: false,
    pageBg: null,
    brandlogo: null,
    microsoftlogin: false,
    googlelogin: false,
    linkedinlogin: false,
    AllowRegister: false,
    bodyTextColor: "#fff",
    loginButtonFillColor: "#f00",
    loginButtonTextColor: "#fff",
    userImage: "",
    userInitials: null,
    userFirstName: "",
    redirectTo: null,
  }),
  components: {
    //ForgotPassword
  },
  computed: {},
  beforeDestroy() {
    clearInterval(interval);
  },
  mounted: function () {
    self.arrEvents = [];
    $("#topmenu").hide();
    $("#leftmenu").hide();
    var urlparam = this.$route.query.lt;
    var hostUrl = location.host.toLowerCase();
    var apiUrl = "";
    if (hostUrl.includes("localhost")) {
      apiUrl =
        "https://us-central1-stagee2monair.cloudfunctions.net/e2monair-stg-decrypt-token";
    } else if (hostUrl.includes("uat")) {
      apiUrl =
        "https://us-central1-uate2monair.cloudfunctions.net/e2monair-uat-decrypt-token";
    } else if (hostUrl.includes("stage")) {
      apiUrl =
        "https://us-central1-stagee2monair.cloudfunctions.net/e2monair-stg-decrypt-token";
    } else {
      apiUrl =
        "https://us-central1-e2monair.cloudfunctions.net/e2monair-prd-decrypt-token";
    }
    var postData = {
      token: urlparam,
    };
    console.log(JSON.stringify(postData));
    $.ajax({
      url: apiUrl,

      headers: {
        "Content-Type": "application/json",
      },
      beforeSend: function () {},
      type: "POST",
      credentials: "include",
      crossDomain: true,
      dataType: "json",
      processData: false,
      data: JSON.stringify(postData),

      success: function (data) {
        if (data.status >= 0) {
          self.showLogin = false;
          self.redirectTo = data.result.redirectTo;
          self.FirebaseLoginWithAuth(data.result.email, data.result.password);
        } else {
          $("#btnLogin").val("Log In");
          $("#h3HeaderLabel").text(
            "Login failed! Invalid username or password"
          );
          document.getElementById("dvOtherMsg").innerText =
            "Login failed! Invalid username or password";
          $("#Othermsg-modal").modal("show");
          self.showLogin = true;
          return false;
        }
      },
      error: function (xhr, status, error) {
        $("#btnLogin").val("Log In");
        document.getElementById("dvOtherMsg").value =
          "Error in authentication process,please try again later. Error:" +
          error;
        $("#Othermsg-modal").modal("show");
      },
    });
  },
  beforeMount() {
    $("#topmenu").hide();
    $("#leftmenu").hide();
  },

  created() {
    self = this;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    store.commit("ClearState", this);
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      this.result = HOSTURL ? HOSTURL : "onair.e2m.live";
    } else {
      this.result = HOSTURL ? HOSTURL : location.host;
    }
    this.getBrandingJsonIfCloudfrontNotPresent(this.result);
  },

  methods: {
    getBrandingJsonIfCloudfrontNotPresent(hostName) {
      var path = APIs.googleSoragePath;
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          if (res.data.reCAPTCHA) {
            self.allowreCAPTCHA = res.data.reCAPTCHA;
          }
          self.clientId = res.data.ClientId;
          if (res.data.EnableEmailOnlyLogin) {
            self.EnableEmailOnlyLogin = res.data.EnableEmailOnlyLogin;
          }
          // if (res.data.TermsOfUseText) {
          //   document.getElementById("divPrivacyPolicy").innerHTML =
          //     res.data.TermsOfUseText;
          // }
          // if (res.data.Infotext) {
          //   if (res.data.Infotext.endsWith("</p>")) {
          //     document.getElementById(
          //       "spnInfoText"
          //     ).innerHTML = res.data.Infotext.substring(
          //       0,
          //       res.data.Infotext.length - 4
          //     ).substring(3, res.data.Infotext.length);
          //   } else {
          //     document.getElementById("spnInfoText").innerHTML =
          //       res.data.Infotext;
          //   }
          // }

          if (res.data.Favicon != undefined) {
            if (res.data.Favicon != "") {
              var link =
                document.querySelector("link[rel*='icon']") ||
                document.createElement("link");
              link.type = "image/x-icon";
              link.rel = "shortcut icon";
              link.href = res.data.Favicon; // 'http://www.stackoverflow.com/favicon.ico';
              document.getElementsByTagName("head")[0].appendChild(link);
            }
          }

          self.bodyTextColor = res.data.LoginAssets.bodyTextColor;
          self.loginButtonFillColor = res.data.LoginAssets.loginButtonFillColor;
          self.loginButtonTextColor = res.data.LoginAssets.loginButtonTextColor;
          self.buttonBackgroundColor =
            res.data.LoginAssets.loginButtonFillColor;
          self.buttonRecoverTextColor =
            res.data.LoginAssets.loginButtonTextColor;
          this.pageBg = self.getCDNUrl(res.data.LoginAssets.bg2732x2048);
          this.brandlogo = self.getCDNUrl(res.data.LoginAssets.logo);
          this.linkedinlogin = res.data.SocialAuths[0].LinkedIn;
          this.googlelogin = res.data.SocialAuths[0].Google;
          this.microsoftlogin = res.data.SocialAuths[0].Microsoft;
          //this.AllowRegister = res.data.AllowRegister;
          this.hostExistcnt = 1;

          $(document).attr("title", "Login - " + res.data.ClientName);
          store.commit("addClientID", {
            id: res.data.ClientId,
            name: res.data.ClientName,
          });
          store.commit("addAuth", {
            Microsoft: res.data.SocialAuths.Microsoft,
            google: res.data.SocialAuths.Google,
            linkedin: res.data.SocialAuths.LinkedIn,
          });
          store.commit("addBranding", {
            bg: self.getCDNUrl(res.data.LoginAssets.bg2732x2048),
            logo: self.getCDNUrl(res.data.LoginAssets.logo),
            favicon: self.getCDNUrl(res.data.Favicon),
            bg2: self.getCDNUrl(res.data.EventListAssets.bg2048x2732),
            banner: self.getCDNUrl(res.data.EventListAssets.banner2048x88),
            bodyTextColor: self.getCDNUrl(res.data.LoginAssets.bodyTextColor),
            mobileBanner: self.getCDNUrl(
              res.data.EventListAssets.banner750x103
            ),
          });

          $(".login-form input[type='submit']").css(
            "background",
            self.loginButtonFillColor
          );
          $(".login-form input[type='submit']").css(
            "color",
            self.loginButtonTextColor
          );

          $(".login-head").css("color", res.data.LoginAssets.bodyTextColor);
          $(".clsStatement").css("color", res.data.LoginAssets.bodyTextColor);
          $(".clscheckbox").css("color", res.data.LoginAssets.bodyTextColor);

          $(".clscheckbox p").css("color", res.data.LoginAssets.bodyTextColor);
          $(".login-section p").css(
            "color",
            res.data.LoginAssets.bodyTextColor
          );
          $(".p.term-amd-c.pt-5.text-center").css(
            "color",
            res.data.LoginAssets.bodyTextColor
          );
          this.DynamicColor = res.data.LoginAssets.bodyTextColor;

          $(":root").css("--body-text-color", this.DynamicColor);
          self.AllowRegister = res.data.AllowRegister;
        })
        .catch((error) => {
          console.log("getBrandingJson: " + error);
        });
      self.setLoaded();
    },
    FirebaseLoginWithAuth(emailId, password) {
      if (self.hostExistcnt <= 0) {
        document.getElementById("dvOtherMsg").innerText =
          "Please login using the correct E2M OnAir URL";
        $("#Othermsg-modal").modal("show");

        return false;
      }
      if (emailId === "" || password === "") {
        document.getElementById("dvOtherMsg").innerText =
          "Wrong Url! please try with proper one.";
        $("#Othermsg-modal").modal("show");
        return false;
      }

      var apiUrl = APIs.FirebaseAuthApi;
      var postData = {
        emailId: emailId,
        password: password,
      };
      $.ajax({
        url: apiUrl,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {},
        type: "POST",
        // mode: 'cors',
        credentials: "include",
        crossDomain: true,
        dataType: "json",
        processData: false,
        data: JSON.stringify(postData),
        success: function (data) {
          console.log(`Api Success Execution time:`, new Date());
          if (data.status >= 0) {
            self.userImage = self.getCDNUrl(data.data.ProfilePictureURL);
            self.userInitials = common.getInitials(data.data.Name);
            self.userFirstName = data.data.FirstName;
            document.getElementById("overlay-test").style.display = "flex";
            firebase
              .auth()
              .signInWithCustomToken(data.customToken)
              .then(function (res) {
                console.log(`custom token Success Execution time:`, new Date());
                res.user
                  .getIdToken(true)
                  .then((idToken) => {
                    var decoded = jwt_decode(idToken);
                    console.log(
                      `get token Success Execution time:`,
                      new Date()
                    );
                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    self.$store.commit("addToken", idToken);
                    self.$store.commit("setCurrentLoggedInTime", decoded.exp);
                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";
                    ////////// After token and cookies set send to event////////////////////
                    store.commit("setLoginType", "Login");
                    var userData = data.data;
                    var userRoles = userData.UserRoles;
                    var roles = [];
                    if (userRoles != undefined) {
                      userRoles.forEach(function (role) {
                        roles.push(role.RoleID);
                      });
                    }
                    store.commit("addAttendeeID", userData.UserId);
                    store.state.userId = userData.UserId;
                    store.state.userRole = userRoles;
                    store.commit("addUser", {
                      id: userData.UserId,
                      Email: userData.Email,
                      name: userData.Name,
                      fname: userData.FirstName,
                      lname: userData.LastName,
                      profilepic: userData.ProfilePictureURL,
                      company: userData.Company,
                      title: userData.Designation,
                      phone: userData.Phone,
                      roles: roles,
                    });
                    if (data.userEvents.result[0].events.length > 1) {
                      // self.$store.commit(
                      //   "setClientEventBranding",
                      //   data.userEvents.result[0].client.isCustomEventBranding
                      // );
                      $("#btnLogin").prop("disabled", true);
                      console.log(
                        `before push Success Execution time:`,
                        new Date()
                      );
                      router.push({ name: "EventList" });
                    } else if (data.userEvents.result[0].events.length == 0) {
                      document.getElementById("dvOtherMsg").innerText = self.$t(
                        "login.eventnotpublished"
                      );
                      $("#Othermsg-modal").modal("show");
                      $("#btnLogin").val(self.$t("login.title"));
                      self.loginText = self.$t("login.title");
                    } else {
                      self.getEventDetails(data);
                    }
                  })
                  .catch((err) => {
                    console.log("err=====", err);
                  });
              })
              .catch(function (e) {
                console.log(e);
                self.loginText = self.$t("login.title");
              });
          } else {
            $("#btnLogin").val(self.$t("login.title"));

            self.loginText = self.$t("login.title");
            self.showSnackbar(
              self.$t("login.loginfailedvaildemailandpwd"),
              "error",
              "top"
            );

            self.loginText = self.$t("login.title");
            return false;
          }
        },
        error: function (xhr, status, error) {
          self.loginText = self.$t("login.title");
          document.getElementById("dvOtherMsg").value =
            self.$t("login.errorinauth") + error;
          $("#Othermsg-modal").modal("show");
        },
      });
    },
    getEventDetails(data) {
      var userData = data.data;
      var email = userData.Email;
      var userRoles = userData.UserRoles;
      var isClientAdmin = false;
      var isEventAdmin = false;
      var roles = [];
      if (userRoles != undefined) {
        userRoles.forEach(function (role) {
          if (role.RoleID == 2) {
            isClientAdmin = true;
          } else if (role.RoleID == 3) {
            isEventAdmin = true;
          }
          roles.push(role.RoleID);
        });
      }
      var channelPrefix = "OAUAT";
      this.createLoginCookieForVideo(userData.UserId, channelPrefix);
      store.commit("addUser", {
        id: userData.UserId,
        Email: email,
        name: userData.Name,
        fname: userData.FirstName,
        lname: userData.LastName,
        profilepic: userData.ProfilePictureURL,
        company: userData.Company,
        title: userData.Designation,
        phone: userData.Phone,
        roles: roles,
      });
      var result = data.userEvents.result;
      var events = [];
      var i;
      var j;
      for (i = 0; i < result.length; ++i) {
        for (j = 0; j < result[i].events.length; j++) {
          if (!isClientAdmin && !isEventAdmin) {
            if (result[i].events[j].IsPublished == true) {
              events.push(result[i].events[j]);
            }
          } else {
            events.push(result[i].events[j]);
          }
        }
      }
      store.commit("setMappedEvent", events);

      store.commit("addEventCount", events.length);

      if (events.length == 0) {
        document.getElementById("dvOtherMsg").innerText = self.$t(
          "login.eventnotpublished"
        );
        $("#Othermsg-modal").modal("show");
        $("#btnLogin").val(self.$t("login.title"));
        self.loginText = self.$t("login.title");
      } else if (events.length > 1) {
        $("#btnLogin").prop("disabled", true);
        router.push({ name: "EventList" });
      } else {
        $("#btnLogin").prop("disabled", true);
        if (self.$store.state.staySignedIn) {
          self.$store.state.historyEvent = events[0];
        }
        self.goToEvent(events);
      }
    },
    goToEvent: async function (eventDoc) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var email = obj.user[0].Email;
      var eventData = eventDoc[0];
      store.commit("addEventID", eventData.EventId);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      store.commit("setBrandingJsonUrl", eventData.brandingJsonUrl);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });
      analytics.AddUserLogin(
        eventData.EventCollectionName,
        eventData.EventFullName,
        location.pathname,
        "click",
        "action",
        obj.loginType,
        obj.user[0].id,
        obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
        obj.user[0].Email,
        obj.ClientIP
      );
      /*++++++++ Font style EventCustomCSS.json JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName +
            "/Branding/CustomStyle/EventCustomCSS.json"
        );
        if (brandingData.data.customClientFont != undefined) {
          store.commit("AddEventFont", {
            FontPath: brandingData.data.customClientFont.FontPath,
            FontFamily: brandingData.data.customClientFont.FontFamily,
          });
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }
      /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      await db
        .collection(eventData.EventCollectionName)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("Email", "==", email)
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (doc) => {
            var AttendeeID = doc.data().AttendeeId;
            store.commit("addAttendeeID", AttendeeID);
            try {
              brandingData = await self.getBrandingJSONDetails(
                eventData.EventCollectionName + "/Branding/Branding.json"
              );
              if (brandingData.data != undefined) {
                this.item = brandingData.data;

                var bannerDymension = "2048x88";
                var EventBgDymension = "2732x2048";
                var logoDymension = "960x192";

                store.commit("addEventBranding", {
                  eventBGImage:
                    brandingData.data.eventBGImage[EventBgDymension],
                  eventLogo: brandingData.data.eventLogo[logoDymension],
                  topBar: brandingData.data.headerColorsHexCode["topBar"],
                  headerBar: brandingData.data.headerColorsHexCode["headerBar"],
                  fontBar: brandingData.data.headerColorsHexCode["fontBar"],
                  sideNavigationAndIconColor:
                    brandingData.data.headerColorsHexCode[
                      "sideNavigationAndIconColor"
                    ],
                  banner: brandingData.data.banner[bannerDymension],
                  mobileBanner: self.getCDNUrl(
                    brandingData.data.banner["750x103"]
                  ),
                  shareBanner: self.getCDNUrl(
                    brandingData.data.banner["1200x628"]
                      ? brandingData.data.banner["1200x628"]
                      : ""
                  ),
                  themeName: brandingData.data["appColorHexCodeType"],
                });
                $("#btnLoadMenu").click();
                this.getMeetingSettings();
                this.getAdvExpoStatus();
                this.getDynamicFont();

                let landingURL = "Lobby";
                if (
                  eventData.DefaultLandingURL &&
                  landingURLOptions[eventData.DefaultLandingURL] &&
                  landingURLOptions[eventData.DefaultLandingURL] != ""
                ) {
                  landingURL = landingURLOptions[eventData.DefaultLandingURL];
                }
                if (landingURL === "ExhibitorsHall") {
                  this.onExpoSelection();
                  store.commit("setAdvExpo", true);
                }
                if (eventData.EventId == "E1631615573088") {
                  router.push({
                    name: "Lobby",
                    params: {
                      sid: eventDoc.id,
                      eCol: eventData.EventCollectionName,
                      ename: eventData.EventFullName,
                      estartdt: eventData.EventStartDate,
                      eenddt: eventData.EventEndDate,
                      tzone: eventData.TimeZone,
                    },
                  });
                } else {
                  router.push({
                    name: self.redirectTo ? self.redirectTo : landingURL,
                    params: {
                      sid: eventDoc.id,
                      eCol: eventData.EventCollectionName,
                      ename: eventData.EventFullName,
                      estartdt: eventData.EventStartDate,
                      eenddt: eventData.EventEndDate,
                      tzone: eventData.TimeZone,
                    },
                  });
                }
              }
            } catch (e) {
              console.log("Error in Branding Json Fetch--", e);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createLoginCookieForVideo: function (UserID, channelPrefix) {
      var cookieExpDate = new Date();
      var minutes = 1440 * 7; //7 days
      cookieExpDate.setTime(cookieExpDate.getTime() + minutes * 60 * 1000);
      var val = channelPrefix + "_" + UserID.toString();
      document.cookie =
        "vuid=" +
        val +
        "; expires=" +
        cookieExpDate +
        "; path=/;domain=.e2m.live;secure=true";
    },
    setLoaded() {
      this.Loginloaded = true;
    },
    getDynamicFont: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.EventFont != undefined) {
        if (obj.EventFont.length > 0) {
          var urlpath = "";
          if (obj.EventFont[0].FontPath != "") {
            if (obj.EventFont[0].FontFamily != "") {
              urlpath = obj.EventFont[0].FontPath;

              var newStyle = document.createElement("style");
              newStyle.appendChild(
                document.createTextNode(
                  "\
@font-face {\
    font-family: " +
                    obj.EventFont[0].FontFamily +
                    ";\
    src:" +
                    urlpath +
                    " ;\
}\
"
                )
              );

              document.head.appendChild(newStyle);

              $(
                "<style>* { font-family: '" +
                  obj.EventFont[0].FontFamily +
                  "' !important }</style>"
              ).appendTo("head");
            }
          } else {
            $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
              "head"
            );
          }
        }
      }
    },
    getMeetingSettings: function () {
      debugger;
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          debugger;
          var res = response.data;
          var MObj = new Object();
          MObj.Slot = res.data.Slots;
          MObj.StartDate = res.data.StartDate;
          MObj.EndDate = res.data.EndDate;
          MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
          MObj.AvailabilityToTime = res.data.AvailabilityToTime;
          MObj.ButtonLabel = res.data.ButtonLabel;
          MObj.Duration = res.data.Duration;
          if (res.data.ByTimezone !== undefined) {
            MObj.ByTimezone = res.data.ByTimezone;
          } else {
            MObj.ByTimezone = false;
          }
          if (res.data.Items && res.data.Items.length > 0) {
            MObj.Items = res.data.Items;
          }

          store.commit("addMeetingSettings", MObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAdvExpoStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          // this.SubscribeForWebPush(); //kk
          querySnapshot.forEach((doc) => {
            if (doc.data().EnableEnhancedExpoMode === true) {
              store.commit("setAdvExpo", true);
            } else {
              store.commit("setAdvExpo", false);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onExpoSelection() {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().EnableEnhancedExpoMode === true) {
                  router.push("/exhibitorshall");
                  store.commit("setAdvExpo", true);
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    //Moved from Lobby to EventSelection----END
  },
};
</script>

<style>
:root {
  --body-text-color: #5a646e;
}
.or {
  white-space: nowrap;
}
.login-form input[type="email"],
.login-form input[type="password"] {
  background: rgba(255, 255, 255, 0.9);
}

.login-form input::placeholder {
  color: var(--body-text-color) !important;
}

.login-form input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--body-text-color) !important;
}

.login-form input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--body-text-color) !important;
}
</style>

<style scoped>
.login-page-wrapper {
  background-size: cover;
}
#overlay-test {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  cursor: pointer;
}
.login-attendee {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-attendee .attendee-img-hld {
  width: 132px;
  height: 132px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 54px;
  text-transform: uppercase;
  border: 1px solid #f2f2f2;
  background-color: #ebeff2;
  color: #6d6f7b;
}
.login-attendee .attendee {
  color: rgb(28, 29, 38);
  font-size: 24px;
  font-weight: 500;
}
.login-attendee .welcome {
  font-size: 24px;
  padding-right: 5px;
}
</style>
